export default class Config {
    static ROLE_STAFF = 'staff';
    static ROLE_ADMIN = 'admin';

    static STATUS_DELETED = 'deleted';
    static STATUS_USING = 'using';
}